module.exports = __webpack_public_path__ + "img/wishBorder.3ffbb22f.png";